export default "__VITE_ASSET__BKuzIBGw__"